export default "__VITE_ASSET__8314b844__"